import { render, staticRenderFns } from "./MonthlyRequstsByModulesReportDetail.vue?vue&type=template&id=815c8642&scoped=true&"
import script from "./MonthlyRequstsByModulesReportDetail.vue?vue&type=script&lang=js&"
export * from "./MonthlyRequstsByModulesReportDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815c8642",
  null
  
)

export default component.exports